import { takeLatest, put, all, call } from 'redux-saga/effects';
import { LOAD_STATISTICS, setStatistics } from './reducer';
import { getRequest } from '../../../utilities/requests';
import { history } from '../../../utilities/history';

function handleLoadUserStatistics() {
  return getRequest('/users/statistics');
}
function handleLoadCommissionStatistics() {
  return getRequest('/commissions/statistics');
}

function* handleLoadStatistics() {
  try {
    const { users, commissions } = yield all({
      users: call(handleLoadUserStatistics),
      commissions: call(handleLoadCommissionStatistics)
    });
    yield put(setStatistics(users.data, commissions.data.details));
  } catch (error) {
    history.push('/error');
  }
}

export function* loadStatisticsSaga() {
  yield takeLatest(LOAD_STATISTICS, handleLoadStatistics);
}
